<!-- Orbi panel toasts (PCSA-13169 / PCSA-13171). Success toast per Figma: a
     full-height green band with a white-circle check on the left, the message on
     a white body, and a grey close (×) on the right. The shared container renders
     the queue; this template is the Orbi look for each toast. -->
<patient-ui-app-toasts [scope]="scope" [toastTemplate]="orbiToast"></patient-ui-app-toasts>

<ng-template #orbiToast let-toast>
  <div class="orbi-toast">
    <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    </ng-template>
    <ng-template #text>
      <!-- Green band + the white `check_circle` glyph (the circle is the glyph's
           own body; the tick is the band showing through it — see the SCSS). -->
      <span class="orbi-toast__band" aria-hidden="true">
        <span class="orbi-toast__check material-icons-round">{{ toast.icon }}</span>
      </span>
      <span class="orbi-toast__text">{{ toast.textOrTpl }}</span>
      <button type="button" class="orbi-toast__close material-icons-round" aria-label="Dismiss" (click)="remove(toast)">close</button>
    </ng-template>
  </div>
</ng-template>
